import { render, staticRenderFns } from "./OrderHistoryScreen.vue?vue&type=template&id=b2143e9a&scoped=true"
import script from "./OrderHistoryScreen.vue?vue&type=script&lang=js"
export * from "./OrderHistoryScreen.vue?vue&type=script&lang=js"
import style0 from "./OrderHistoryScreen.vue?vue&type=style&index=0&id=b2143e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2143e9a",
  null
  
)

export default component.exports